import React from 'react'
import axios from 'axios'
import styled  , {keyframes} from 'styled-components'
import Navbar from './Navbar'
import background from '../images/alternativebackground.png'
import SocialButtons from './design/socialbuttons';
import backgroundvideo from '../videos/backvideo.mp4'
import { fadeInRightBig } from 'react-animations';

const FadeInAnimation = keyframes`${fadeInRightBig}`;

//new background 23 10 61

const Video = styled.video`
min-width:100%;
min-height:100%;
position:fixed;
background-size:cover;
overflow:hidden;
z-index:-100;
`

const Container = styled.div`
width:100%;
background: url(${background});
height:100vh;
background-size:cover;                      /* <------ */
background-repeat:no-repeat;
margin: 0 auto;
color:#EAE1E1;
animation: 0.6s ${FadeInAnimation};
@media (max-height:880px) {
    width:100%;
    
}

@media (max-width:512px) {
    width:100%;
    height:100%;
}

@media (min-height:900px){
    width:100%;
    min-height:100vh;
}
`

const Wrapper = styled.div`
width:100%;
text-align:center;
display:grid;
font-family: 'Barlow', sans-serif;
grid-template-columns: repeat(1fr);
grid-gap:0px;

@media (min-height:900px){
    grid-gap:40px;
}

`

const HeroContent = styled.div`
width:90%;
margin:0 auto;
margin-top:60px;
text-align:left;
display:grid;
grid-template-columns: repeat(1,auto);

@media (max-width:1200px) {
margin-top:0px;
}

@media (min-width:1400px) {
    display:grid;
    grid-template-columns: repeat(1,auto);
    grid-gap:30px;
}

`

const Title = styled.div`
font-family: 'Barlow';
font-style: normal;
font-weight: bold;
font-size: 58px;
line-height: 65px;
text-align: left;
letter-spacing: 0.06em;
color: #F2F2F2;
margin:20px;

@media (max-width:800px) {
    font-size:52px;
}
@media (min-width:1400px) {
    font-size:68px;
}

@media (max-width:512px) {
    width:80%;
    height:80%;
    font-size:45px;
}

@media (max-width:320px) {
    width:80%;
    height:80%;
    font-size:32px;
}
`

const Subtitle = styled.div`
font-family: 'Barlow';
font-style: normal;
font-weight: 300;
font-size: 30px;
line-height: 36px;
color: #EAE1E1;
width:60%;
margin:20px;
@media (min-width:1400px) {
    font-family: 'Barlow';
font-style: normal;
font-weight: 100;
font-size: 42px;
line-height: 1.2;
color: #EAE1E1;
width:60%;
margin:20px;
}

@media (max-width:320px) {

    font-size:22px;
}
`

const Button = styled.button`
width:190px;
border: 3px solid #EAE1E1;
box-sizing: border-box;
background:none;
color:white;
font-size:22px;
margin:20px;
transition: 1s cubic-bezier(0.075, 0.82, 0.165, 1);
cursor:pointer;
&:hover{
    background:white;
    color: #170A3D;
    text-decoration: line-through #EAE1E1;
    transform: translateY(-10px);
}


@media (max-width:500px) {
    width:120px;
    font-size:18px;
    height:60px;
    margin-bottom:50px;
}
`


const LineRight = styled.div`
position: fixed;
right: 0px;
bottom: 0px;
border: 5px solid #EAE1E1;
transform: rotate(-90px);
height:80%;
margin:40px;

@media (max-width:870px) {
    border:none;
}
`

const LineBottom = styled.div`
width: 60%;
margin:40px;
position:fixed;
right: 0px;
bottom: 0px;
border: 5px solid #F2F2F2;
transform: rotate(-180px);

@media (max-width:870px) {
    border:none;
}

@media (max-width:780px) {
    width:50%;
}
`


const Home = () => {
    return(
        
            <Container>

                <LineBottom/>
                <LineRight/>
                <Wrapper>
                    <Navbar/>
                    <HeroContent>
                        <Title>
                            FRONT-END DEVELOPER
                        </Title>
                        <Subtitle>
                        I'm an Economics Student at the University of Cagliari, Remote front-end developer, graphic designer and a computer science, Technology enthusiast.
                        </Subtitle>
                            <a href='https://www.fiverr.com/marcomoi?up_rollout=true' target='_blank'>
                                <Button >
                                    <p style={{padding:'0px'}}>HIRE ME</p>
                                </Button>
                            </a>
                        <SocialButtons/>
                    </HeroContent>
                </Wrapper>   
            </Container>
        
    )
}


export default Home;
